<!--
 * @Author: Ashley.Liu
 * @Date: 2022-04-27 09:42:14
 * @LastEditTime: 2022-05-31 11:51:00
 * @Description: desc
-->
<template>
  <zm-dropdown
    class="asyncmq-systerm-news"
    v-if="notices && notices.length"
    placement="bottom"
    trigger="click"
  >
    <div class="zm-dropdown-link">
      <zm-badge
        is-dot
        class="item"
      >
        <div class="news pdr-sm">
          <i class="zm-icon-Megaphone"></i>
          Notices
        </div>
      </zm-badge>
      <i class="zm-icon-down zm-icon--right"></i>
    </div>
    <zm-dropdown-menu
      slot="dropdown"
      :hide-timeout="350"
      class="asyncmq-systerm-news-items"
    >
      <zm-dropdown-item
        v-for="(item,index) in notices"
        :key="`notice${index}`"
      >
        <i class="zm-icon-Megaphone mgr-sm"></i>
        <span v-html="$xss(item.content)"></span>
      </zm-dropdown-item>
    </zm-dropdown-menu>
  </zm-dropdown>
</template>

<script>
import { getUsafeConfig } from '@/api/unsafeConfig'
export default {
  data () {
    return {
      notices: []
    }
  },
  created () {
    getUsafeConfig('systermNotices').then(({ data }) => {
      this.notices = data?.value && JSON.parse(data.value)
      this.notices = this.notices?.filter(({ inUse, effectTime }) => {
        if (!inUse || !effectTime.length) {
          return inUse
        }
        const now = new Date().getTime()
        function getTime (timeItem) {
          if (!timeItem) return new Date().getTime()
          return new Date(timeItem).getTime()
        }
        return getTime(effectTime[0]) < now && getTime(effectTime[1]) >= now
      })
      // this.notices = this.notices.map(item => {
      //   item.content = this.urlDistinguish(item.content)
      //   return item
      // })
    })
  },
  methods: {
    urlDistinguish (str) {
      var reg = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig
      str = str.replace(reg, "<a href='$1' class='jump' target='_blank'>$1</a>")
      return str
    }

  }
}
</script>

<style lang="scss">
.asyncmq-systerm-news {
  .zm-dropdown-link {
    margin-right: 16px;
    height: 32px;
    vertical-align: middle;
  }
}
.asyncmq-systerm-news-items.zm-popper.zm-dropdown-menu {
  max-width: 500px;
  padding: 4px 12px;
  .zm-dropdown-menu__item:not(:first-child) {
    border-top: 1px solid #d8dce5;
  }
  .zm-dropdown-menu__item {
    white-space: pre-wrap;
    line-height: 27px;
    font-weight: bold;
  }
  .zm-dropdown-menu__item a {
    color: #0e71eb;
  }
}
</style>
